import { render, staticRenderFns } from "./ApprovedSickLeaveMailing.vue?vue&type=template&id=452e8f5b"
import script from "./ApprovedSickLeaveMailing.vue?vue&type=script&lang=js"
export * from "./ApprovedSickLeaveMailing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports